<script>
import {mapGetters} from 'vuex'

export default {
    name: 'create-item',
    computed:
    {
        ...mapGetters({
            clients: 'clients'
        }),
    },
    data(){
        return {
            item: {
                client_id: null,
                name: '',
            },
            types: [
                {id:'offerCreate',name:'New Offer'},
                {id:'landingPageCreate',name:'New Landing Page'},
                {id:'stackedOfferCreate',name:'New Stacked Offer'},
            ],
            type: null,
            error: null,
        }
    },
    watch:
    {
        '$route': 
        {
            handler()
            {
                this.setData()
            },
            immediate: true
        }
    },
    methods:
    {
        setData()
        {
            this.$store.dispatch('clientsFetch')
        },

        selectClient(value)
        {
            this.item.client_id = value.id
        },
        selectType(value)
        {
            this.type = value
        },
        backToHome()
        {
            this.$router.push({ name: 'welcome'})
        },
        save()
        {
            if (this.type && this.item.client_id && this.item.name != '') {
                this.error = false
                this.$store.dispatch(this.type.id, this.item).then((res) => {
                    let name = ''
                    switch (this.type.id) {
                        case 'offerCreate':
                            name = 'offer-edit'
                            break;
                        case 'landingPageCreate':
                            name = 'landing-page-edit'
                            break;
                        case 'stackedOfferCreate':
                            name = 'stacked-offer-edit'
                            break;
                    }
                    this.$router.replace({
                        name: name,
                        params: {item: res.id, slug: 'creative'}
                    })
                })
            } else {
                this.error = true
            }
        },
    },
}
</script>

<template lang="html">
    <div class="create-offer secondary-container container">
        <simple-panel footer heading>
            <div slot="heading" class="font-weight-bold">
                Create
            </div>
            <div>
                <div class="row mb-3">
                    <div class="col-2 text-right pt-2 font-weight-bold">
                        Channel
                    </div>
                    <div class="col-6">
                        <custom-multiselect
                        labelClasses="font-weight-bold text-right pr-3"
                        :options="clients.data"
                        searchable
                        placeholder="Select channel"
                        modelLabel="name"
                        @selected="selectClient">
                        </custom-multiselect>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2 text-right pt-1 font-weight-bold">
                        Create
                    </div>
                    <div class="col-10">
                        <div class="row">
                            <div class="col-4">
                                <custom-multiselect
                                labelClasses="font-weight-bold text-right pr-3"
                                class="mb-3"
                                :options="types"
                                modelLabel="name"
                                @selected="selectType"
                                ></custom-multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2 pt-1 font-weight-bold text-right">
                        Listing name
                    </div>
                    <div class="col-6">
                        <simple-input
                        class="mb-3"
                        type="text"
                        v-model="item.name"
                        placeholder="Type a name"
                        noRadius
                        ></simple-input>
                    </div>
                </div>
                <div v-if="error" class="row">
                    <div class="col-2"></div>
                    <div class="col-6 text-orange text-sm">
                        All fields are required
                    </div>
                </div>
            </div>
            <div slot="footer" class="text-right">
                <custom-button classes="white text-uppercase w-120 " text="Discard" @buttonClick="backToHome"></custom-button>
                <custom-button classes="blue text-white text-uppercase w-120 " text="Next" @buttonClick="save"></custom-button>
            </div>
        </simple-panel>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/Create.vue